/*
* Palo Alto Theme
*
* Use this file to add custom Javascript to Palo Alto.  Keeping your custom
* Javascript in this fill will make it easier to update Palo Alto. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Listen for clicks on the + and - buttons in cart.

  function attachListeners() {
    const buttons = document.querySelectorAll("[data-quantity-plus], [data-quantity-minus]");
    if (buttons.length === 0) return;

    buttons.forEach(btn => {
      if (!btn._hasListener) {
        btn._hasListener = true;
        btn.addEventListener("click", onQuantityButtonClick, true);
      }
    });
  }

  function toggleUIInputs(disabled) {
    // Disable the add/remove buttons and quantity.
    for (const holder of document.querySelectorAll("[data-quantity-holder]")) {
      for (const child of holder.children) {
        child.disabled = disabled;
      }
    }

    // Disable the "remove" link.
    for (const el of document.querySelectorAll(".cart__item__remove")) {
      el.disabled = disabled;
      el.style.pointerEvents = disabled ? "none" : "";
    }
  }

  let blockHandler = false;
  function onQuantityButtonClick(event) {
    // If this is a synthetic run, skip this run and unlock for future runs.
    if (blockHandler) {
      blockHandler = false;
      return;
    }

    const target = event.currentTarget;
    const isAdd = target.attributes["data-quantity-plus"] ? true : false;
    const container = target.parentElement.parentElement.parentElement.parentElement;

    const itemName = container.attributes["data-item-title"].value.toLowerCase();
    if (!itemName.includes("photo book") && !itemName.includes("photobook")) return;

    // Get the current item's quantity.
    const itemQuantity = parseInt(target.parentElement.querySelector("input").value);

    // If the item is to be deleted, mediaclip handles that.
    if (!isAdd && itemQuantity === 1) return;

    // Get the sibling (if present).
    const sibling = container.nextElementSibling;
    if (!sibling) return;

    const siblingIndex = parseInt(sibling.attributes["data-item-index"].value);

    // Check if the sibling is additional pages.
    if (!sibling.attributes["data-item-title"].value.startsWith("Photobook additional pages")) return;
  
    // Get the quantity of the sibling.
    const siblingQuantity = parseInt(sibling.querySelector(`input[name="updates[]"]`).value);
    const extraPagesQuantityPerItem = Math.ceil(siblingQuantity / itemQuantity);

    // Prevent other updates from taking place before this.
    event.stopImmediatePropagation();
    event.preventDefault();
    
    // Update the quantity of the additional pages to reflect new amount.
    toggleUIInputs(true);
    fetch("/cart/change", {
      "headers": {
        "content-type": "application/json",
        "accept": "application/json"
      },
      "body": JSON.stringify({ line: siblingIndex, quantity: extraPagesQuantityPerItem * (itemQuantity + (isAdd ? 1 : -1)) }),
      "method": "POST"
    })
    .catch(error => {
      console.error(error);
      toggleUIInputs(false);
    })
    .then(() => {
      blockHandler = true;
      target.dispatchEvent(new MouseEvent("click", { bubbles: true }));
    });
  }

  const observer = new MutationObserver(() => {
    attachListeners();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
})();
